// extracted by mini-css-extract-plugin
module.exports = {"o136zb5f":"o136zb5f","w2fo0b5":"w2fo0b5"};